import "./marketingBanner.scss";

interface MarketingBannerProps {
    message: string;
    linkText?: string;
    linkUrl?: string;
    /** Muted italic text shown only while the message is empty (the editor's preview). */
    placeholder?: string;
    className?: string;
}

/**
 * The marketing banner across the top of the Partner Dashboard (MPN-2171). Presentational:
 * Admin > Banners previews with it and the dashboard renders it, so both look the same.
 */
export default function MarketingBanner({ message, linkText, linkUrl, placeholder, className }: MarketingBannerProps) {
    const text = message.trim();
    const link = linkText?.trim();
    return (
        <div
            className={`marketing-banner${className ? ` ${className}` : ""}`}
            role="region"
            aria-label="Announcement"
            title={text}
        >
            {!text && placeholder ? (
                <span className="marketing-banner__placeholder">{placeholder}</span>
            ) : (
                <>
                    {text}
                    {link && <a href={linkUrl || "#"} target="_blank" rel="noopener noreferrer">{link}</a>}
                </>
            )}
        </div>
    );
}
